export const sequenceDetails = {
  grounding: { 
    name: "It's A *Sorta*|Wonderful|Life", 
    beats: ['aHero', 'meetAndGreet', 'catalyst'], 
    arc: 'setUp',
    color: '#2196F3',
    lightColor: '#E3F2FD',
    description: 'Establishes the protagonist\'s everyday life, relationships, and the world they inhabit. Shows their current beliefs, routines, and what\'s missing beneath the surface.'
  },
  disruption: { 
    name: "Oh Snap", 
    beats: ['umAndAh', 'leap'], 
    arc: 'setUp',
    color: '#1976D2',
    lightColor: '#E3F2FD',
    description: 'Something shifts that the protagonist can\'t ignore or undo. The balance is broken, forcing them to respond and step into a journey they didn\'t ask for.'
  },
  exploration: {
    name: "Onward and|Upward*ish*",
    beats: ['upAndAtEm', 'complication'],
    arc: 'buildUp',
    color: '#4CAF50',
    lightColor: '#E8F5E8',
    description: 'The protagonist actively pursues their goal with growing momentum and hope. They\'re learning and making progress, but the emotional cost starts to show.'
  },
  opposition: {
    name: "Things Just|Got Real",
    beats: ['touchAndGo', 'turn'],
    arc: 'buildUp',
    color: '#fdd835',
    lightColor: '#FFFDE7',
    description: 'Real pushback arrives with bigger resources and tougher choices. Allies start to waver and the protagonist begins to crack under pressure.'
  },
  reckoning: {
    name: "No Turning|Back Now",
    beats: ['downAndDirty', 'risk'],
    arc: 'breakUp',
    color: '#fea02e',
    lightColor: '#FFF3E0',
    description: 'Backed into a corner, the protagonist makes choices they never imagined they\'d consider. Lines blur, morals bend, and desperation takes over.'
  },
  collapse: {
    name: "What the Hell|Was I Thinking?",
    beats: ['crashAndBurn', 'fall'],
    arc: 'breakUp',
    color: '#D32F2F',
    lightColor: '#FFEBEE',
    description: 'The antagonist delivers brutal blows, allies are lost, and the protagonist breaks both inside and out—hitting their lowest point.'
  },
  reflection: {
    name: "Hello Sunshine",
    beats: ['riseAndShine', 'reveal'],
    arc: 'wrapUp',
    color: '#E91E63',
    lightColor: '#FCE4EC',
    description: 'In the quiet after the storm, something shifts. With nothing left to lose, the protagonist finally sees clearly what they really need to do.'
  },
  rebirth: {
    name: "New Skin,|Old Soul",
    beats: ['triedAndTested', 'theHero'],
    arc: 'wrapUp',
    color: '#a85cd9',
    lightColor: '#F3E5F5',
    description: 'The protagonist returns not as who they were, but as who they\'ve become. They act with clarity and intention, no longer just reacting to circumstances.'
  }
};